import type { ReactNode } from 'react';

export const symbol_shift_lock_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-110.18q0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h620q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q802.75-80 790-80H170q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5ZM182-430q-19.36 0-27.18-17t4.18-32l143-179 43 43-98 125h133v210h200v-100l60 60v70q0 12.75-8.62 21.37Q622.75-220 610-220H350q-12.75 0-21.37-8.63Q320-237.25 320-250v-180H182Zm321-421 298 372q12 15 4.18 32T778-430H627q-5.57 0-10.78-2-5.22-2-10.22-7-14-14-6.34-32.5Q607.31-490 627-490h86L480-786l-77 97q-8.13 11.37-21.07 12.19Q369-676 359-685.69q-8.46-8.2-9.23-19.76Q349-717 357-726l100-125q8.88-11 22.94-11T503-851ZM812-63 47-827q-9-9.07-9-21.53Q38-861 47.05-870q9.06-9 21.5-9Q81-879 90-870l765 765q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q821-54 812-63ZM469-576Zm-42 129Z"
		/>
	</svg>
);
